// Logger with default options
import logger from 'redux-logger'

export default logger;